import { Component } from '@angular/core';

@Component({
  selector: 'df-funnel-overview-content-generator',
  templateUrl: './funnel-overview-content-generator.component.html',
  styleUrls: ['./funnel-overview-content-generator.component.scss'],
})
export class FunnelOverviewContentGeneratorComponent {}
